import { RECEIVE_INVOICES, UPDATE_INVOICES_FILTERS, FAILURE_INVOICES, UNLOAD_INVOICE, REQUEST_INVOICES } from '../constants/action_types';
import { fetchCustomerInvoices } from '../api/api';
import { isEmpty } from "lodash";
import moment from 'moment'

const receiveInvoices = (data) => ({
    type: RECEIVE_INVOICES,
    data
});

const failureInvoices = () => ({
    type: FAILURE_INVOICES,
});

const updateFiltersInvoices = (filters) => dispatch => {
    dispatch({
        type: UPDATE_INVOICES_FILTERS,
        filters
    })
    dispatch(requestInvoices());
}

const requestInvoices = (reset = false) => (dispatch, getState) => {
    const isFetching = getState().account.invoices.isFetching;
    const page = getState().account.invoices.nextPage;
    if (!isFetching) {
        const filters = getState().account.invoices.filters;
        const reachedEnd = getState().account.invoices.reachedEnd;

        // let from = moment(new Date(filters.year, filters.month)).format();
        // let to = moment(new Date(filters.year, filters.month + 1, 0)).format();
        let from = filters.month!=null ? moment(new Date(filters.year, filters.month)).format() : moment(new Date(filters.year, 0)).format();
        let to= filters.month!=null ? moment(new Date(filters.year, filters.month+1, 0)).format() : moment(new Date(filters.year, 11,31)).format();

        let normalizedFilters = {
            "from": from,
            "to": to,
            "query": filters.query
        }

        if (!reachedEnd) {
            dispatch({
                type: REQUEST_INVOICES,
                reset
            })
            return fetchCustomerInvoices(normalizedFilters, page)
                .then(res => {

                    if (!res.ok || !isEmpty(res.body.errors)) {
                        return dispatch(failureInvoices());
                    }
                    else {
                        return res.json()
                    }
                })
                .then(json => {
                    return dispatch(receiveInvoices(json));
                })
        }
    }
}

const unloadInvoice = () => ({
    type: UNLOAD_INVOICE,
})

export {
    updateFiltersInvoices,
    requestInvoices,
    unloadInvoice
};
